import { createQueryKeySet } from '@akin-home/utils/react-query';

export const dashboard_query_keys = createQueryKeySet({ key: 'dashboards' });
